/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext, useRef } from "react";
import LeftPanel from "../../../components/LeftPanel";
import Header from "../../../components/Header";
import spinner from "../../../images/reports-spinner.gif";
import spinnerSVG from "../../../images/spinner.svg";
import { v4 as uuidv4 } from "uuid";
import JsPDF from 'jspdf';
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
// IMPORTING ICONS
import { ChevronUpIcon, ChevronDownIcon, MenuAlt2Icon } from "@heroicons/react/solid";
import { PencilIcon } from "@heroicons/react/outline";
import { Cancel } from "@mui/icons-material";

// IMPORTING REACT-DATEPICKER
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import OrderSummaryTable from "../../../components/OrderSummaryTable";
import Context from "../../../context/context";

const columnsArray = [
  "ALL",
  "Local Order No",
  "Created At",
  "Completed At",
  "Customer Mobile",
  "Customer Name",
  "Order Total",
  "Working Day",
  "Order Type",
  "Section & Seat",
  "Payment Mode",
  "Payment"
]

const toggleWarning = async ({ message, type, timeout }) => {
  clearInterval(sessionStorage.getItem("notification-warning-timeout"));
  document.querySelector(".notification-message").innerText = await message;
  document.querySelector(".notification-container").classList.add(type);

  const timeoutId = setTimeout(() => document.querySelector(".notification-container").classList.remove(type), timeout);
  sessionStorage.setItem("notification-warning-timeout", timeoutId);
}

const OrdersReport = () => {

  const [isItemAvilableOpen, setIsItemAvilableOpen] = useState(false);
  return (
    <>
      <LeftPanel
        setIsItemAvilableOpen={setIsItemAvilableOpen}
        isItemAvilableOpen={isItemAvilableOpen}
      />
      <Header />
      <div className="orders-report-container">
        <div id="heading">
          <h2>Orders</h2>
        </div>
        <FiltersCollection />
      </div>
    </>
  );
};

function FiltersCollection() {

  const context = useContext(Context);
  const { editedOrderData, setUnAuthPopup } = context;
  let restrictions = JSON.parse(sessionStorage.getItem("restrictions")) || []
  const [paymentModes, setPaymentModes] = useState(null);
  const [sections, setSections] = useState(null);
  const [tableColumns, setTableColumns] = useState(null);
  const [dateformat, setDateformat] = useState(null);
  const [datefrom, setDatefrom] = useState(null);
  const [dateto, setDateto] = useState(null);
  const [filtersSelections, setFiltersSelections] = useState({});
  const [filteredLocalReports, setFilteredLocalReports] = useState([]);
  const [IDBSectionsState, setIDBSectionsState] = useState(null);
  const [IDBPaymentModesState, setIDBPaymentModesState] = useState(null);
  const [IDBUserState, setIDBUserState] = useState(null);
  const [IDBSeatsState, setIDBSeatsState] = useState(null);

  const [isDropDownVisible, setIsDropDownVisible] = useState(null);
  const [isMouseOutsideSidebar, setIsMouseOutsideSidebar] = useState(null);
  const [reportsRenderCollection, setReportsRenderCollection] = useState(null);
  const [reportsData, setReportsData] = useState(null);
  const [pages, setPages] = useState(null);
  const [filtersRefCollection, setFiltersRefCollection] = useState(null);
  const [isMouseOutsideDropDown, setIsMouseOutsideDropDown] = useState(null);
  const [orders_database, setOrders_database] = useState([]);
  const [table_loading, setTable_loading] = useState(null);

  const [payment_modes_total, setPayment_modes_total] = useState(null);
  const [totalAmount, setTotalAmount] = useState(null);
  const [reportsLength, setReportsLength] = useState(0);

  const [showPayModesTotal, setShowPayModesTotal] = useState(null)
  const [isMouseOverToggleButton, setIsMouseOverToggleButton] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const [loading, setLoading] = useState(false);
  let searchBar = useRef({ active: false, type: null, value: '' });
  const resetSearchBar = () => {
    searchBar.current = { active: false, type: null, value: '' }
    if (document.querySelector('#searchbar-container')?.querySelector('input'))
      document.querySelector('#searchbar-container').querySelector('input').value = '';
  }

  useEffect(() => {
    let DBOpenReq = window.indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    DBOpenReq.onerror = (err) => console.log(err);
    DBOpenReq.onsuccess = (ev) => {
      let db = ev.target.result;
      let getReq = db
        .transaction("payment_modes", "readonly")
        .objectStore("payment_modes")
        .getAll();

      getReq.onsuccess = (data) => {
        let namesCollection = ["ALL", "UPI"];
        setIDBPaymentModesState(data.target.result);
        data.target.result.forEach((i) => namesCollection.push(i.payment_mode_name));
        setPaymentModes(namesCollection);
      };

      db = ev.target.result;
      getReq = db
        .transaction("seats", "readonly")
        .objectStore("seats")
        .getAll();

      getReq.onsuccess = (data) => {
        setIDBSeatsState(data.target.result);
      };

      getReq = db.transaction("user", "readwrite").objectStore("user").getAll();
      getReq.onsuccess = (data) => {
        setIDBUserState(data.target.result);
        const loggedInUser = data.target.result.find(
          (user) => user.user_uuid === localStorage.getItem("user_uuid")
        );

        if (loggedInUser?.past_order_columns?.length > 0)
          setTableColumns(loggedInUser?.past_order_columns?.map(c => c === "Selected Mode Amount" ? "Payment" : c));
        else
          setTableColumns(columnsArray);

        if (!loggedInUser?.past_order_columns) {
          loggedInUser.past_order_columns = columnsArray;
          db.transaction("user", "readwrite").objectStore("user").put(loggedInUser);
        }
      };

      getReq = db
        .transaction("outlet", "readonly")
        .objectStore("outlet")
        .getAll();
      getReq.onsuccess = (data) => {
        let namesCollection = ["ALL"];
        let res = data.target.result[0];
        setIDBSectionsState(res.section_details);

        setDatefrom(new Date(+res.current_working_day));
        setDateto(new Date(+res.current_working_day));
        // console.log( (new Date(+res.current_working_day)).toLocaleString())

        res.section_details.sort(
          (a, b) => +a.section_sort_order - +b.section_sort_order
        );
        res.section_details.forEach((section) =>
          namesCollection.push(section.section_name)
        );

        setSections(namesCollection);
        setDateformat(
          res.setup.date_format
            .toLowerCase()
            .replaceAll("mm", "MM")
            .replaceAll("-", "/")
        );
      };
    };
  }, []);

  useEffect(() => {
    if (!editedOrderData) return;
    console.log(editedOrderData);
    let order = filterOrdersFunction([editedOrderData], filtersRefCollection)[0];
    console.log(order)
    if (!order) return;

    let elementIndex = reportsRenderCollection.findIndex(i => i["UUID"] === order["UUID"]);
    let nextIndex = elementIndex + 1;

    let preElementData = reportsRenderCollection.slice(0, elementIndex);
    let postElementData = reportsRenderCollection.slice(nextIndex, reportsRenderCollection?.length + 1);
    preElementData.push(order);

    let newArray = preElementData.concat(postElementData);
    setReportsRenderCollection(newArray);
  }, [editedOrderData]);

  useEffect(() => {
    if (paymentModes && sections) {
      setFiltersSelections({
        "Payment Mode": paymentModes,
        "Placed By": ["ALL", "ADMIN", "CAPTAIN"],
        "Order Type": [
          "ALL",
          "Seats",
          "Take Away",
          "Delivery",
          "Zomato",
          "Swiggy",
          "Meals",
        ],
        "Floor/Screen": sections,
      });
    }
  }, [paymentModes, sections]);

  const handleChangeRaw = (value, which) => {
    if (value === "tomorrow") {
      const tomorrow = new Date(new Date().setDate(new Date().getDate() + 1));
      which === "from" ? setDatefrom(tomorrow) : setDateto(tomorrow);
    } else if (value === "yesterday") {
      const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
      which === "from" ? setDatefrom(yesterday) : setDateto(yesterday);
    }
  };

  function canBeFoundOffline() {

    const offline_order_upto = +localStorage.getItem('offline-order-upto');
    const availableToDate = +localStorage.getItem('current-working-day');
    const availableFromDate = new Date(new Date(availableToDate).setDate(new Date(availableToDate).getDate() - offline_order_upto + 1)).getTime();

    // console.log(new Date(availableToDate), "availableToDate")
    // console.log(new Date(availableFromDate), "availableFromDate")

    const selectedFromDate = new Date(datefrom).getTime();
    const selectedToDate = new Date(dateto).getTime();

    // console.log(new Date(selectedFromDate), "selectedFromDate")

    console.log(`seleted date : ${new Date(selectedFromDate)} - ${new Date(selectedToDate)}`);
    console.log(`available order from ${new Date(availableFromDate)} to ${new Date(availableToDate)}`);

    if (selectedFromDate >= availableFromDate && selectedToDate <= availableToDate)
      return true;
    else
      return false;
  }

  async function getReportStatics(orders, filters) {

    console.log(filters["Payment Mode"]);
    const paymodes_obj = {};
    let ordersTotal = 0;

    orders.forEach(i => {

      i.payment_details.forEach(j => {
        let amount = +paymodes_obj[j.payment_mode_uuid] || 0;

        if (!filters["Payment Mode"] || filters["Payment Mode"].includes(j.payment_mode_uuid))
          if (+j.amount)
            paymodes_obj[j.payment_mode_uuid] = amount + +j.amount
      })

      if (+i.order_total)
        ordersTotal = ordersTotal + +i.order_total;
    })

    console.log(paymodes_obj, ordersTotal);

    const modesTotalArray = [];

    for (const key in paymodes_obj) {
      modesTotalArray.push({
        mode_name: key === 'UPI'
          ? 'UPI'
          : IDBPaymentModesState?.find(i => i.payment_mode_uuid === key)?.payment_mode_name,
        total_amount: paymodes_obj[key]
      })
    }

    console.log(modesTotalArray, ordersTotal);

    setPayment_modes_total(modesTotalArray);
    setTotalAmount(ordersTotal)
  }

  function generateRenderCollection(orders) {

    const renderCollection = [];

    function getOrderTypeStr(value) {
      if (value === 0) return "Seats";
      else if (value === 1) return "Take away";
      else if (value === 2) return "Delivery";
      else if (value === 3) return "Zomato";
      else if (value === 4) return "Swiggy";
      else if (value === 5) return "Meals";
    }

    function getSectionAndSeat(uuid) {

      const seat = IDBSeatsState.find(
        (seat) => seat.seat_uuid === uuid
      );

      let section;
      if (seat)
        section = IDBSectionsState.find(
          (section) => section.section_uuid === seat.section_uuid
        );

      if (section)
        return `${section.section_name} ${seat.seat_name}`;
      else
        return null
    }

    function getPaymentModesStr(modes) {
      const modesNames = [];
      modes.forEach((i) => {

        i.payment_mode_uuid &&
          i.payment_mode_uuid.length > 0 &&
          modesNames.push(
            IDBPaymentModesState.find(
              (m) => m.payment_mode_uuid === i.payment_mode_uuid
            )?.payment_mode_name
          )
      }
      );

      return modesNames.join(", ");
    }

    function getPayModesAmt(modes) {

      let total = filtersSelections["Payment Mode"]?.filter(i => i.toLowerCase() !== 'all')
        ?.reduce((sum, mode_name) => {
          const mode_uuid = IDBPaymentModesState.find(mode => mode.payment_mode_name === mode_name)?.payment_mode_uuid
          return sum += (modes.find(i => i.payment_mode_uuid === mode_uuid)?.amount || 0)
        }, 0);

      return total;
    }

    function getDateTime(ms) {
      return `${new Date(
        +ms || ms
      ).toDateString()} at ${new Date(
        +ms || ms
      ).toLocaleTimeString()}`;
    }

    orders.forEach(o => {

      const renderingObj = {
        "UUID": o.order_uuid,
        "Created At": o.created_at && getDateTime(o.created_at),
        "Completed At": o.completed_at && getDateTime(o.completed_at),
        "Customer Mobile": o.customer_mobile,
        "Customer Name": o.customer_name,
        "Local Order No": o.local_order_id,
        "Order Total": o.order_total,
        "Working Day": new Date(+o.working_day || o.working_day).toDateString(),
        "Order Type": getOrderTypeStr(+o.order_type),
        "Section & Seat": o.seat_uuid ? getSectionAndSeat(o.seat_uuid) : "-",
        "Payment Mode": o?.payment_details?.[0]?.payment_mode_uuid === 'UPI' ? 'UPI' : getPaymentModesStr(o.payment_details),
        "Payment": o?.payment_details?.[0]?.payment_mode_uuid === 'UPI' ? o.payment_details?.[0]?.amount : getPayModesAmt(o.payment_details),
      };

      renderCollection.push(renderingObj);
    });

    return renderCollection
  }

  function filterOrdersFunction(ordersDatabase, fSelections) {

    function inDateRange(date) {
      if (
        +date >= new Date(datefrom).getTime() &&
        +date <= new Date(dateto).getTime()
      )
        return true;
      else
        return false;
    }

    const filteredOrders = ordersDatabase.filter((o) => {

      if (!+o.working_day)
        o.working_day = new Date(o.working_day).getTime();

      if (inDateRange(o.working_day)) {

        // console.log("date matched");
        // console.log(o.payment_details, fSelections["Payment Mode"]);

        if (!fSelections["Payment Mode"] || o.payment_details.some((i) => fSelections["Payment Mode"].includes(i.payment_mode_uuid))) {

          // console.log("passed payment modes");
          if (!fSelections["Order Type"] || fSelections["Order Type"].includes(`${o.order_type}`)) {
            // console.log("passed Order type");

            if (
              +o.order_type !== 0 ||
              (!fSelections["Floor/Screen"] || fSelections["Floor/Screen"].includes(
                IDBSeatsState.find((i) => i.seat_uuid === o.seat_uuid)
                  .section_uuid
              ))
            ) {
              // console.log("passed Floor/Screen");

              if (!fSelections["Placed By"] ||
                o.order_kot_details.some((kot) =>
                  fSelections["Placed By"].includes(
                    `${IDBUserState.find(
                      (user) => user.user_uuid === kot.user_uuid
                    ).user_type}`
                  )
                )
              ) {
                // Passed all filters tests
                // console.log("passed all");
                return o
              }
              else return null
            }
            else return null
          }
          else return null
        }
        else return null
      }
      else return null
    });
    return filteredOrders;
  }

  function searchHandler() {

    document
      ?.querySelector("#filters-sidebar")
      ?.classList.remove("active");
    document
      ?.querySelector("#sidebar-container")
      ?.classList.remove("active");

    let invoke_src_type = searchBar.current?.active ? '1' : '0'

    console.log("datefrom", datefrom.getDate())
    let timeDifference = (new Date(parseFloat(localStorage.getItem("current-working-day")))).getDate()
      - datefrom.getDate()
    console.log("datefrom", (parseInt(restrictions[0]?.other_report_order) || 0), timeDifference)
    if (restrictions.length && (parseInt(restrictions[0]?.other_report_order) || 0) < timeDifference) {
      setUnAuthPopup(true)
      setTimeout(() => setUnAuthPopup(false), 3000)
      return
    }
    // document.querySelector(".tabular-content.report-orders-table").scrollTo(0, 0);
    setTable_loading(true);
    setLoading(false);

    try {

      const fSelections = {};
      const filters = [
        "Payment Mode",
        "Placed By",
        "Order Type",
        "Floor/Screen",
      ];

      // set value refs
      filters.forEach((f, ind, arr) => {
        const selection = [];

        if (document.getElementsByClassName(`${f.toLowerCase().replace(" ", "-")}`)[0].querySelector('#all').checked !== true) {

          Array.from(document.querySelectorAll(`[name="${f}"]`)).forEach(
            (e, i, arr) => {
              const value = e.getAttribute("label-value").toLowerCase();
              if (e.checked) {

                if (value.toLocaleLowerCase() === "all") return
                let valueRef;

                function user_type(str) {
                  if (str === "admin") return '1';
                  else if (str === "captain") return '2';
                }

                if (f === "Payment Mode" && IDBPaymentModesState) {
                  // console.log(value);
                  valueRef = IDBPaymentModesState.find(
                    (mode) => mode.payment_mode_name.toLowerCase() === value
                  ).payment_mode_uuid;
                }
                else if (f === "Floor/Screen") {
                  valueRef = IDBSectionsState.find(
                    (section) => section.section_name.toLowerCase() === value
                  ).section_uuid;
                }
                else if (f === "Order Type") {
                  if (value === "seats") valueRef = '0';
                  else if (value === "take away") valueRef = '1';
                  else if (value === "delivery") valueRef = '2';
                  else if (value === "zomato") valueRef = '3';
                  else if (value === "swiggy") valueRef = '4';
                  else if (value === "meals") valueRef = '5';
                }
                else if (f === "Placed By") {
                  valueRef = user_type(value);
                }

                selection.push(valueRef);
              }
              if (++i === arr.length) fSelections[f] = selection;
            }
          );
          console.log(`selection for ${f} : `, selection);
          console.log(`updated collection : `, fSelections);
          console.log("");
        }
        if (ind + 1 === arr.length)
          setFiltersRefCollection(fSelections);
      });

      let availableOffline = false;

      if (+invoke_src_type === 0)
        availableOffline = canBeFoundOffline();

      if (availableOffline) {

        var results = [];
        sessionStorage.setItem('reports-src', 'IDB');

        let DBOpenReq = window.indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        DBOpenReq.onerror = (err) => console.log(err);
        DBOpenReq.onsuccess = (ev) => {

          let db = ev.target.result;
          let objectStore = db.transaction("Orders", "readonly").objectStore("Orders");

          const reportsReq = objectStore.getAll();
          reportsReq.onsuccess = reportsEvent => {

            results = reportsEvent.target.result;

            const filteredOrders = filterOrdersFunction(results, fSelections);
            console.log(filteredOrders.length);

            filteredOrders.sort((a, b) => {
              if (!a.created_at || !b.created_at) return 0;
              else
                return (
                  new Date(+b.created_at || b.created_at) -
                  new Date(+a.created_at || a.created_at)
                );
            });

            let pages = [];
            let total_pages = Math.ceil((filteredOrders.length) / 200);

            setReportsLength(filteredOrders.length)
            for (let i = 1; i <= total_pages; i++) {
              pages.push(i)
            }
            setPages(pages);
            getReportStatics(filteredOrders, fSelections);

            setFilteredLocalReports(filteredOrders);
            const limitedOrders = filteredOrders.slice(0, 200);
            setOrders_database(limitedOrders);

            const renderingOrders = generateRenderCollection(limitedOrders);

            console.log("all filtered orders collections", limitedOrders);
            console.log("Rendering collection", renderingOrders);

            setReportsRenderCollection(renderingOrders.splice(0, 50));
            setReportsData(renderingOrders);

            setCurrentPage(1);
            setTable_loading(false);
          }
        }
      }
      else {
        var content;
        sessionStorage.setItem('reports-src', 'API');
        const payload = {
          filters: fSelections,
          page: 1,
          outlet_uuid: localStorage.getItem('outlet_uuid')
        }

        if (+invoke_src_type === 0)
          payload.date_range = {
            from: new Date(datefrom).getTime(),
            to: new Date(dateto).getTime()
          }
        else
          payload.search_payload = {
            type: searchBar.current.type,
            value: searchBar.current.value,
          }

        const host = 'https://api.myfooddo.com'
        // const host = 'http://localhost:5000'
        fetch(`${host}/order/reports:true`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(payload),
        })
          .then(res => res.json())
          .then(data => {
            content = data;
            console.log('data fetched from api --------- ', data);

            if (content) {

              if (+content['length'] === 0) return setTable_loading(false);

              if (content['length']) {

                let pages = [];
                let total_pages = Math.ceil((+content['length']) / 200);

                setReportsLength(content['length'])
                for (let i = 1; i <= total_pages; i++) {
                  pages.push(i)
                }
                setPages(pages);
              }

              const modesTotal = content["stats"]["payment_totals"][0];
              const ordersTotal = +content?.stats?.total_amount[0]?.total_amount;

              if (modesTotal) delete modesTotal._id;
              const modesTotalArray = [];

              for (const key in modesTotal) {
                modesTotalArray.push({
                  mode_name: key === "UPI"
                    ? "UPI"
                    : IDBPaymentModesState?.find(i => i.payment_mode_uuid === key)?.payment_mode_name,
                  total_amount: modesTotal[key]
                })
              }

              console.log(modesTotalArray, ordersTotal);

              setPayment_modes_total(modesTotalArray);
              setTotalAmount(ordersTotal);

              console.log(content.result);
              setOrders_database(content.result);
              setFilteredLocalReports([]);

              const renderingOrders = generateRenderCollection(content.result);
              console.log("Rendering collection", renderingOrders);

              setReportsRenderCollection(renderingOrders.splice(0, 50));
              setReportsData(renderingOrders);

              setCurrentPage(1);
              setTable_loading(false);
            }
          });
      }
    } catch (error) {
      console.error(error);
      setTable_loading(false);
    }
  }

  function pageLoad(page) {

    const search_src_type = searchBar.current?.active ? '1' : '0'
    document.querySelector(".tabular-content.report-orders-table").scrollTo(0, 0);
    setTable_loading(true);
    setLoading(false);

    let src = sessionStorage.getItem('reports-src');

    if (+search_src_type === 0)
      src = 'API'

    if (src === 'IDB') {

      const cursor = 200 * (+page - 1);

      console.log(filteredLocalReports);
      const limitedOrders = filteredLocalReports.slice(cursor + 1, cursor + 201);
      setOrders_database(limitedOrders);

      const renderingOrders = generateRenderCollection(limitedOrders);

      console.log("all filtered orders collections", limitedOrders);
      console.log("Rendering collection", renderingOrders);

      setReportsRenderCollection(renderingOrders.splice(0, 50));
      setReportsData(renderingOrders);

      setCurrentPage(page);
      setTable_loading(false);
    }
    else {
      var content;
      const payload = {
        filters: filtersRefCollection,
        page: (+page),
        outlet_uuid: localStorage.getItem('outlet_uuid')
      }

      if (+search_src_type === 0)
        payload.date_range = {
          from: new Date(datefrom).getTime(),
          to: new Date(dateto).getTime()
        }
      else
        payload.search_payload = {
          type: searchBar.current.type,
          value: searchBar.current.value,
        }

      fetch("https://api.myfooddo.com/order/reports:false", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(payload),
      })
        .then(res => res.json())
        .then(data => {
          content = data;
          console.log('data fetched from api --------- ', data);

          setOrders_database(content.result);
          const renderingOrders = generateRenderCollection(content.result);
          console.log("Rendering collection", renderingOrders);

          setReportsRenderCollection(renderingOrders.splice(0, 50));
          setReportsData(renderingOrders);

          setTable_loading(false);
          setCurrentPage(page);
        });
    }
  }

  const getSheetData = async selected => {

    let sheetData;
    let src = sessionStorage.getItem('reports-src');

    if (selected?.toLowerCase()?.includes('current')) sheetData = (reportsRenderCollection || [])?.concat(reportsData || [])
    else if (src === 'IDB') sheetData = generateRenderCollection(filteredLocalReports)
    else {
      const search_src_type = searchBar.current?.active ? '1' : '0'
      const payload = {
        filters: filtersRefCollection,
        page: 'ALL',
        outlet_uuid: localStorage.getItem('outlet_uuid')
      }

      if (+search_src_type === 0) payload.date_range = {
        from: new Date(datefrom).getTime(),
        to: new Date(dateto).getTime()
      }
      else payload.search_payload = {
        type: searchBar.current.type,
        value: searchBar.current.value,
      }

      // const url = "http://localhost:5000/order/reports:false";
      const url = "https://api.myfooddo.com/order/reports:false"
      let res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(payload),
      });

      res = await res.json();
      sheetData = await res.result;
    }

    return sheetData;
  }

  const onScroll = (e) => {

    if (reportsData.length < 1) return;
    setLoading(true);

    try {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollTop + clientHeight >= scrollHeight - 5) {

        const data = reportsData;

        // console.log(reportsData.length)
        // console.log(data.length)

        setReportsRenderCollection(
          reportsRenderCollection.concat(data.splice(0, 50))
        );

        // console.log(reportsData.length)
        // console.log(data.length)

        setReportsData(data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error(error)
    }
  };

  const searchBar_searchHandler = async (e) => {
    e.preventDefault();

    const REF = await { ...JSON.parse(JSON.stringify(searchBar.current)), type: null };
    const regex_collection = {
      local_order_id: /^[A-Za-z][\d]+$/gm,
      customer_mobile: /^[\d]{10}$/gm,
      customer_name: /^[A-Za-z ]*$/gm
    }

    for (const regex_type in regex_collection) {
      if (regex_collection[regex_type].test(REF.value.replace('+91-', ''))) {
        REF.type = regex_type;
        if (regex_type === 'customer_mobile') REF.value = `+91-${REF.value.replace('+91-', '')}`;
        else if (regex_type === 'local_order_id') REF.value = REF.value.toUpperCase();
        break;
      }
    }

    if (!REF.type) {
      toggleWarning({
        message: 'Enter a valid input, i.e. Local Order Id, Customer Name or Customer Mobile',
        type: 'active-red',
        timeout: 4000
      })
      return;
    }

    searchBar.current = { ...REF, active: true };

    console.log("UPDATED", REF);
    console.log("ORIGINAL", searchBar.current);

    searchHandler();
  }

  return (
    <>
      <div id="filters-container">
        <div className="filters-form">
          <div
            className="inputs-container"
            onClick={() => {
              if (isMouseOutsideDropDown) {
                setIsDropDownVisible(null)
              }
              if (isMouseOutsideSidebar) {
                document
                  .querySelector("#filters-sidebar")
                  .classList.remove("active");
                document
                  .querySelector("#sidebar-container")
                  .classList.remove("active");
              }
            }}
          >
            <button
              id="filters-popup-trigger"
              onClick={() => {
                document.querySelector("#filters-sidebar").classList.toggle("active");
                document.querySelector("#sidebar-container").classList.toggle("active");
              }}
              onMouseEnter={() => {
                setIsMouseOutsideSidebar(false);
              }}
              onMouseLeave={() => {
                setIsMouseOutsideSidebar(true);
              }}
            >
              <MenuAlt2Icon style={{ width: "40px" }} />
            </button>

            {dateformat && (
              <>
                <div
                  className="selection-field date-field from orders-page "
                  onClick={() => {
                    setIsDropDownVisible(null);
                    document
                      .querySelector("#filters-sidebar")
                      .classList.remove("active");
                    document
                      .querySelector("#sidebar-container")
                      .classList.remove("active");
                  }}

                >
                  <label htmlFor="date-from">From date</label>
                  <DatePicker
                    id="date-from"
                    className="date-picker test"

                    dateFormat={dateformat}
                    selected={datefrom}
                    maxDate={new Date()}
                    onChange={(date) => {
                      setDatefrom(date);
                      setDateto(date);
                      document.getElementById('date-to').click();
                      document.getElementById('date-to').focus();
                    }}
                    onChangeRaw={(event) =>
                      handleChangeRaw(event.target.value, "from")
                    }
                    wrapperClassName=""
                    shouldCloseOnSelect={true}
                  />
                </div>
                <div
                  className="selection-field date-field to orders-page"
                  onClick={() => {
                    setIsDropDownVisible(null);
                    document
                      .querySelector("#filters-sidebar")
                      .classList.remove("active");
                    document
                      .querySelector("#sidebar-container")
                      .classList.remove("active");
                  }}
                >
                  <label htmlFor="date-to">To date</label>
                  <DatePicker
                    id="date-to"
                    className="date-picker test"
                    dateFormat={dateformat}
                    minDate={datefrom}
                    selected={dateto}
                    maxDate={Date.now()}
                    onChange={(date) => {
                      setDateto(date)
                    }}
                    wrapperClassName=""
                    shouldCloseOnSelect={true}
                  />
                </div>
              </>
            )}

            <button id="filters-search-btn" onClick={(e) => { resetSearchBar(); searchHandler(); }}>
              Search
            </button>

            <div id="rightSided">

              <div className="report-stats container">
                <span>
                  Total Amount : Rs.{totalAmount || 0}
                </span>
                <span>
                  Total Records : {reportsLength}
                </span>
              </div>

              <div
                className={`report-stats pay-mode-toggle ${showPayModesTotal && payment_modes_total ? "active" : null}`}
                onClick={() => setShowPayModesTotal(!showPayModesTotal)}
                onMouseEnter={() => setIsMouseOverToggleButton(true)}
                onMouseLeave={() => setIsMouseOverToggleButton(false)}
              >
                Show Pay Modes Total
              </div>

              {showPayModesTotal && payment_modes_total && <button
                id="pay-modes-table"
                autoFocus={true}
                onBlur={() => !isMouseOverToggleButton && setShowPayModesTotal(false)}
              >
                <table>
                  <thead className="pay-modes-head">
                    <tr>
                      <th>
                        Mode
                      </th>
                      <th>
                        Total
                      </th>
                    </tr>
                  </thead>
                  <tbody className="pay-modes-body">
                    {payment_modes_total?.map(m =>
                      <tr>
                        <td>
                          {m.mode_name}
                        </td>
                        <td>
                          Rs.{m.total_amount}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </button>}

            </div>

            <div
              id="edit-column"
              onMouseEnter={() => setIsMouseOutsideDropDown(false)}
              onMouseLeave={() => setIsMouseOutsideDropDown(true)}
            >
              {tableColumns && columnsArray && (
                <FilterElement
                  key={Math.random()}
                  id={Math.random()}
                  title={"Edit Columns"}
                  options={columnsArray}
                  tableColumns={tableColumns}
                  setTableColumns={setTableColumns}
                  isDropDownVisible={isDropDownVisible}
                  setIsDropDownVisible={setIsDropDownVisible}
                  filtersSelections={filtersSelections}
                  setFiltersSelections={setFiltersSelections}
                />
              )}
            </div>
          </div>
          <div
            id="sidebar-container"
            onClick={() => {
              if (isMouseOutsideSidebar) {
                setIsDropDownVisible(null);
                document
                  .querySelector("#filters-sidebar")
                  .classList.remove("active");
                document
                  .querySelector("#sidebar-container")
                  .classList.remove("active");
              }
            }}
          >
            <div
              id="filters-sidebar"
              onMouseEnter={() => {
                setIsMouseOutsideSidebar(false);
              }}
              onMouseLeave={() => {
                setIsMouseOutsideSidebar(true);
              }}
              onClick={() => {
                if (isMouseOutsideDropDown) {
                  setIsDropDownVisible(null);
                }
              }}
            >
              <h1>All filters</h1>
              <div>
                <div id='searchbar-container'>
                  <input
                    type="text"
                    placeholder="Search for Local Order No. Custo..."
                    title="Seach for Local Order No, Customer Name And Mobile No."
                    defaultValue={searchBar.current?.value}
                    onChange={e => {
                      searchBar.current.value = e.target.value
                      if (e.target.value?.length > 0)
                        e.target.nextElementSibling.disabled = false
                      else
                        e.target.nextElementSibling.disabled = true
                    }}
                  />
                  <button title="Search data from server, selected dates will be ignored" onClick={searchBar_searchHandler} disabled={!searchBar.current?.value}>Search</button>
                </div>

                <div
                  className="sidebar-row"
                  onMouseEnter={() => setIsMouseOutsideDropDown(false)}
                  onMouseLeave={() => setIsMouseOutsideDropDown(true)}
                >
                  {paymentModes && (
                    <FilterElement
                      key={Math.random()}
                      id={Math.random()}
                      title={"Payment Mode"}
                      options={paymentModes}
                      isDropDownVisible={isDropDownVisible}
                      setIsDropDownVisible={setIsDropDownVisible}
                      filtersSelections={filtersSelections}
                      setFiltersSelections={setFiltersSelections}
                    />
                  )}
                  <FilterElement
                    key={Math.random()}
                    id={Math.random()}
                    title={"Placed By"}
                    options={["ALL", "ADMIN", "CAPTAIN"]}
                    isDropDownVisible={isDropDownVisible}
                    setIsDropDownVisible={setIsDropDownVisible}
                    filtersSelections={filtersSelections}
                    setFiltersSelections={setFiltersSelections}
                  />
                </div>

                <div
                  className="sidebar-row"
                  onMouseEnter={() => setIsMouseOutsideDropDown(false)}
                  onMouseLeave={() => setIsMouseOutsideDropDown(true)}
                >
                  <FilterElement
                    key={Math.random()}
                    id={Math.random()}
                    title={"Order Type"}
                    options={[
                      "ALL",
                      "Seats",
                      "Take Away",
                      "Delivery",
                      "Zomato",
                      "Swiggy",
                      "Meals",
                    ]}
                    isDropDownVisible={isDropDownVisible}
                    setIsDropDownVisible={setIsDropDownVisible}
                    filtersSelections={filtersSelections}
                    setFiltersSelections={setFiltersSelections}
                  />
                  {sections && (
                    <FilterElement
                      key={Math.random()}
                      id={Math.random()}
                      title={"Floor/Screen"}
                      options={sections}
                      isDropDownVisible={isDropDownVisible}
                      setIsDropDownVisible={setIsDropDownVisible}
                      filtersSelections={filtersSelections}
                      setFiltersSelections={setFiltersSelections}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div
            id="table-container"
            onClick={() => {
              if (isMouseOutsideDropDown) {
                setIsDropDownVisible(null)
              }
            }}
            style={{ paddingBottom: pages?.length > 1 ? "35px" : '0' }}
          >
            {table_loading && <div id="reports-loading-spinner">
              <img src={spinner} alt="loading reports" />
            </div>}
            <Table
              tableColumns={tableColumns}
              reportsRenderCollection={reportsRenderCollection}
              setReportsRenderCollection={setReportsRenderCollection}
              onScroll={onScroll}
              loading={loading}
              pages={pages}
              pageLoad={pageLoad}
              orders_database={orders_database}
              currentPage={currentPage}
              searchHandler={searchHandler}
              datefrom={datefrom}
              dateto={dateto}
              getSheetData={getSheetData}
            />
          </div>
        </div>
      </div>
    </>
  );
}

function Table({
  tableColumns,
  reportsRenderCollection,
  setReportsRenderCollection,
  onScroll,
  loading,
  pages,
  pageLoad,
  orders_database,
  currentPage,
  searchHandler,
  datefrom,
  dateto,
  getSheetData
}) {
  const [tempOrders, setTempOrders] = useState(null);
  const [showChooseFileModal, setShowChooseFileModal] = useState(false)
  useEffect(() => {
    if (tempOrders) {

      setReportsRenderCollection(tempOrders);
    }
    return setTempOrders(null);
  }, [tempOrders]);

  const sortFunctions = {
    Local_Order_No: function (op) {
      const orders = reportsRenderCollection;

      if (op === "asc") {
        orders.sort((a, b) => {
          if (!a["Local Order No"] && !b["Local Order No"]) return 0;
          else
            return (
              +a["Local Order No"].slice(1) - +b["Local Order No"].slice(1)
            );
        });
      } else if (op === "desc") {
        orders.sort((a, b) => {
          if (!a["Local Order No"] && !b["Local Order No"]) return 0;
          else
            return (
              +b["Local Order No"].slice(1) - +a["Local Order No"].slice(1)
            );
        });
      }
      setTempOrders(orders);
    },

    Customer_Mobile: function (op) {
      const orders = reportsRenderCollection;

      if (op === "asc")
        orders.sort((a, b) => {
          if (!+a["Customer Mobile"] && !+b["Customer Mobile"]) return 0;
          else return +a["Customer Mobile"] - +b["Customer Mobile"];
        });
      else if (op === "desc")
        orders.sort((a, b) => {
          if (!+a["Customer Mobile"] && !+b["Customer Mobile"]) return 0;
          else return +b["Customer Mobile"] - +a["Customer Mobile"];
        });

      setTempOrders(orders);
    },

    Customer_Name: function (op) {
      const orders = reportsRenderCollection;

      if (op === "asc")
        orders.sort((a, b) => {
          if (!a["Customer Name"] && !b["Customer Name"]) return 0;
          else return a["Customer Name"].localeCompare(b["Customer Name"]);
        });
      else if (op === "desc")
        orders.sort((a, b) => {
          if (!a["Customer Name"] && !b["Customer Name"]) return 0;
          else return b["Customer Name"].localeCompare(a["Customer Name"]);
        });

      setTempOrders(orders);
    },

    Order_Type: function (op) {
      const orders = reportsRenderCollection;

      if (op === "asc")
        orders.sort((a, b) => {
          if (!a["Order Type"] && !b["Order Type"]) return 0;
          else return a["Order Type"].localeCompare(b["Order Type"]);
        });
      else if (op === "desc")
        orders.sort((a, b) => {
          if (!a["Order Type"] && !b["Order Type"]) return 0;
          else return b["Order Type"].localeCompare(a["Order Type"]);
        });

      setTempOrders(orders);
    },

    Order_Total: function (op) {
      const orders = reportsRenderCollection;

      if (op === "asc")
        orders.sort((a, b) => {
          if (!+a["Order Total"] && !+b["Order Total"]) return 0;
          else return +a["Order Total"] - +b["Order Total"];
        });
      else if (op === "desc")
        orders.sort((a, b) => {
          if (!+a["Order Total"] && !+b["Order Total"]) return 0;
          else return +b["Order Total"] - +a["Order Total"];
        });

      setTempOrders(orders);
    },

    Payment: function (op) {
      const orders = reportsRenderCollection;

      if (op === "asc")
        orders.sort((a, b) => {
          if (!+a["Payment"] && !+b["Payment"])
            return 0;
          else return +a["Payment"] - +b["Payment"];
        });
      else if (op === "desc")
        orders.sort((a, b) => {
          if (!+a["Payment"] && !+b["Payment"])
            return 0;
          else return +b["Payment"] - +a["Payment"];
        });

      setTempOrders(orders);
    },

    Payment_Mode: function (op) {
      const orders = reportsRenderCollection;

      if (op === "asc")
        orders.sort((a, b) => {
          if (!a["Payment Type"] && !b["Payment Type"]) return 0;
          else return a["Payment Type"].localeCompare(b["Payment Type"]);
        });
      else if (op === "desc")
        orders.sort((a, b) => {
          if (!a["Payment Type"] && !b["Payment Type"]) return 0;
          else return b["Payment Type"].localeCompare(a["Payment Type"]);
        });

      setTempOrders(orders);
    },

    "Section_&_Seat": function (op) {
      const orders = reportsRenderCollection;

      if (op === "asc")
        orders.sort((a, b) => {
          if (!a["Section & Seat"] && !b["Section & Seat"]) return 0;
          else return a["Section & Seat"].localeCompare(b["Section & Seat"]);
        });
      else if (op === "desc")
        orders.sort((a, b) => {
          if (!a["Section & Seat"] && !b["Section & Seat"]) return 0;
          else return b["Section & Seat"].localeCompare(a["Section & Seat"]);
        });

      setTempOrders(orders);
    },

    Created_At: function (op) {
      const orders = reportsRenderCollection;

      if (op === "asc")
        orders.sort((a, b) => {
          if (!a["Created At"] || !b["Created At"]) return 0;
          else
            return (
              new Date(a["Created At"].replace(" at", "")) -
              new Date(b["Created At"].replace(" at", ""))
            );
        });
      else if (op === "desc")
        orders.sort((a, b) => {
          if (!a["Created At"] || !b["Created At"]) return 0;
          else
            return (
              new Date(b["Created At"].replace(" at", "")) -
              new Date(a["Created At"].replace(" at", ""))
            );
        });

      setTempOrders(orders);
    },

    Completed_At: function (op) {
      const orders = reportsRenderCollection;

      if (op === "asc")
        orders.sort((a, b) => {
          if (!a["Completed At"] || !b["Completed At"]) return 0;
          else
            return (
              new Date(a["Completed At"].replace(" at", "")) -
              new Date(b["Completed At"].replace(" at", ""))
            );
        });
      else if (op === "desc")
        orders.sort((a, b) => {
          if (!a["Completed At"] || !b["Completed At"]) return 0;
          else
            return (
              new Date(b["Completed At"].replace(" at", "")) -
              new Date(a["Completed At"].replace(" at", ""))
            );
        });

      setTempOrders(orders);
    },

    Working_Day: function (op) {
      const orders = reportsRenderCollection;

      if (op === "asc")
        orders.sort((a, b) => {
          if (!a["Working Day"] && !b["Working Day"]) return 0;
          else return new Date(a["Working Day"]) - new Date(b["Working Day"]);
        });
      else if (op === "desc")
        orders.sort((a, b) => {
          if (!a["Working Day"] && !b["Working Day"]) return 0;
          else return new Date(b["Working Day"]) - new Date(a["Working Day"]);
        });

      setTempOrders(orders);
    },
  };

  const [isOrdersTablePopUpOpen, setIsOrdersTablePopUpOpen] = useState(null);
  const [orderTableData, setOrderTableData] = useState({});

  function toggleOrderTable(uuid) {
    const _order = orders_database.find(o => o.order_uuid === uuid);
    setOrderTableData({ id: uuidv4() + uuidv4(), status: true, value: _order });
  }

  useEffect(() => {
    if (orderTableData)
      setIsOrdersTablePopUpOpen(true);
  }, [orderTableData])

  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const downloadHandler = async (selected, callback) => {
    let sheetData = await getSheetData(selected);

    const ws = XLSX.utils.json_to_sheet(sheetData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = await XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, "orders-report.xlsx");
    callback && callback()
    setShowChooseFileModal(false);
  }

  const printDocument = () => {
    const report = new JsPDF('portrait', 'pt', 'a4');
    report.html(document.getElementById('tableToPrint')).then(() => {
      report.save('report.pdf');
    });
  }

  return (
    <>
      {
        isOrdersTablePopUpOpen && orderTableData?.value && (
          <OrderSummaryTable
            value={orderTableData.value}
            isOrdersTablePopUpOpen={isOrdersTablePopUpOpen}
            setIsOrdersTablePopUpOpen={setIsOrdersTablePopUpOpen}
            searchHandler={searchHandler}
            renderPaymentPopup={true}
            tableContainerStyle={{ left: '15px', paddingRight: '100px' }}
          />
        )
      }
      <div
        onScroll={(e) => onScroll(e)}
        className="tabular-content report-orders-table"

      >
        <table>

          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", position: "absolute", width: "60px", right: "10vw", top: "50px" }}>
            <button
              className="hoverIcons"
              style={{ cursor: "pointer" }}
              onClick={() => setShowChooseFileModal(true)}
            >Xls
            </button>
            <button className="hoverIcons" onClick={printDocument} style={{ cursor: "pointer" }}>PDF</button>
          </div>

          <thead id="tableHeadToPrint">
            <tr>
              {reportsRenderCollection &&
                reportsRenderCollection?.length > 0 &&
                tableColumns &&
                tableColumns.map((column) => {
                  return (
                    <th key={Math.random()}>
                      <div className="t-head-element">
                        <span>{column}</span>
                        <div className="sort-buttons-container">
                          <button onClick={() => sortFunctions[column.replaceAll(" ", "_")]("asc")} >
                            <ChevronUpIcon className="sort-up sort-button" />
                          </button>
                          <button onClick={() => sortFunctions[column.replaceAll(" ", "_")]("desc")}>
                            <ChevronDownIcon className="sort-down sort-button" />
                          </button>
                        </div>
                      </div>
                    </th>
                  );
                })}
            </tr>
          </thead>
          <tbody id="tableBodyToPrint">
            {reportsRenderCollection && reportsRenderCollection?.length > 0 ? (
              reportsRenderCollection.map((order) => {
                return (
                  <tr
                    className="report-fields"
                    onClick={e => { toggleOrderTable(order["UUID"]); }}
                  >
                    {tableColumns &&
                      tableColumns.map((label) =>
                        label === "Local Order No" ? (
                          <td key={Math.random()} className={`${label.toLowerCase().replaceAll(" ", "_")}`}>
                            {order[label] || "-"}
                          </td>
                        ) : (
                          <td key={Math.random()} className={`${label.toLowerCase().replaceAll(" ", "_")}`} >
                            {order[label] || "-"}
                          </td>
                        )
                      )}
                  </tr>
                );
              })
            ) : (
              <div id="no_reports" style={{ display: !showChooseFileModal ? 'block' : 'none' }}>No Orders</div>
            )}
          </tbody>

        </table>

        <div style={{ display: "none" }}>
          <div id='tableToPrint' style={{ width: "595px" }}>
            <h2 style={{ width: "100%", textAlign: "center" }}>{localStorage.getItem("outlet-name")}</h2>
            <div style={{ display: "inline" }}>
              <div style={{ display: "inline", fontSize: "small" }}>From : {sessionStorage.getItem("date_format")
                ?.replace(
                  "mm",
                  ("00" + ((new Date(datefrom))?.getMonth() + 1)?.toString())?.slice(-2)
                )
                ?.replace(
                  "yy",
                  ("0000" + (new Date(datefrom))?.getFullYear()?.toString())?.slice(-4)
                )
                ?.replace(
                  "dd",
                  ("00" + (new Date(datefrom))?.getDate()?.toString())?.slice(-2)
                )}</div>
              <div style={{ display: "inline", fontSize: "small", marginLeft: "30px" }}>To :{sessionStorage.getItem("date_format")
                ?.replace(
                  "mm",
                  ("00" + ((new Date(dateto))?.getMonth() + 1)?.toString())?.slice(-2)
                )
                ?.replace(
                  "yy",
                  ("0000" + (new Date(dateto))?.getFullYear()?.toString())?.slice(-4)
                )
                ?.replace(
                  "dd",
                  ("00" + (new Date(dateto))?.getDate()?.toString())?.slice(-2)
                )}</div>
            </div>
            <table >
              <thead id="tableHeadToPrint">

                <tr style={{ border: "1px solid black" }}>
                  {reportsRenderCollection &&
                    reportsRenderCollection?.length > 0 &&
                    tableColumns &&
                    tableColumns.map((column) => {
                      return (
                        <th key={Math.random()} style={{ fontSize: "x-small", width: "fit-content", textAlign: "center" }}>
                          <div >
                            <span>{column}</span>

                          </div>
                        </th>
                      );
                    })}
                </tr>
              </thead>
              <tbody id="tableBodyToPrint">
                {reportsRenderCollection && reportsRenderCollection?.length > 0 ? (
                  reportsRenderCollection.map((order) => {
                    return (
                      <tr
                        style={{ border: "1px solid black" }}
                      >
                        {tableColumns &&
                          tableColumns.map((label) =>
                            label === "Local Order No" ? (
                              <td
                                key={Math.random()}

                                style={{ fontSize: "x-small", width: "fit-content", textAlign: "center" }}
                              >
                                {order[label] || "-"}
                              </td>
                            ) : (
                              <td
                                key={Math.random()}
                                style={{ fontSize: "x-small", width: "fit-content", textAlign: "center" }}

                              >
                                {order[label] || "-"}
                              </td>
                            )
                          )}
                      </tr>
                    );
                  })
                ) : (
                  <div id="no_reports">No Orders</div>
                )}
              </tbody>
            </table>
            <div style={{ fontSize: "small", marginTop: "30px" }}>Generated using FoodDo at {
              sessionStorage.getItem("date_format")
                ?.replace(
                  "mm",
                  ("00" + ((new Date())?.getMonth() + 1)?.toString())?.slice(-2)
                )
                ?.replace(
                  "yy",
                  ("0000" + (new Date())?.getFullYear()?.toString())?.slice(-4)
                )
                ?.replace(
                  "dd",
                  ("00" + (new Date())?.getDate()?.toString())?.slice(-2)
                )}{" "}{(new Date()).toLocaleTimeString(navigator.language, {
                  hour: '2-digit',
                  minute: '2-digit'
                })
              }</div>
          </div>
        </div>
        <div style={{ display: "none" }}>

          <table id='xlsTableToPrint'>
            <thead id="tableHeadToPrint">
              <tr><th colSpan={tableColumns?.length || 1} style={{ fontSize: "x-large" }}>{localStorage.getItem("outlet-name")}</th></tr>
              <tr>
                <th colSpan={parseInt(tableColumns?.length / 2)}>From : {sessionStorage.getItem("date_format")
                  ?.replace(
                    "mm",
                    ("00" + ((new Date(datefrom))?.getMonth() + 1)?.toString())?.slice(-2)
                  )
                  ?.replace(
                    "yy",
                    ("0000" + (new Date(datefrom))?.getFullYear()?.toString())?.slice(-4)
                  )
                  ?.replace(
                    "dd",
                    ("00" + (new Date(datefrom))?.getDate()?.toString())?.slice(-2)
                  )}</th>
                <th colSpan={parseInt(tableColumns?.length / 2)}>To :{sessionStorage.getItem("date_format")
                  ?.replace(
                    "mm",
                    ("00" + ((new Date(dateto))?.getMonth() + 1)?.toString())?.slice(-2)
                  )
                  ?.replace(
                    "yy",
                    ("0000" + (new Date(dateto))?.getFullYear()?.toString())?.slice(-4)
                  )
                  ?.replace(
                    "dd",
                    ("00" + (new Date(dateto))?.getDate()?.toString())?.slice(-2)
                  )}</th>
              </tr>
              <tr >
                {reportsRenderCollection &&
                  reportsRenderCollection?.length > 0 &&
                  tableColumns &&
                  tableColumns.map((column) => {
                    return (
                      <th key={Math.random()} >
                        <div >
                          <span>{column}</span>

                        </div>
                      </th>
                    );
                  })}
              </tr>
            </thead>
            <tbody id="tableBodyToPrint" style={{ border: " solid black" }}>
              {reportsRenderCollection && reportsRenderCollection?.length > 0 ? (
                reportsRenderCollection.map((order) => {
                  return (
                    <tr

                    >

                      {tableColumns &&
                        tableColumns.map((label) =>
                          label === "Local Order No" ? (
                            <td
                              key={Math.random()}


                            >
                              {order[label] || "-"}
                            </td>
                          ) : (
                            <td
                              key={Math.random()}


                            >
                              {order[label] || "-"}
                            </td>
                          )
                        )}
                    </tr>
                  );
                })
              ) : (
                <div id="no_reports">No Orders</div>
              )}
              <tr><td colSpan={tableColumns?.length || 1}></td></tr>
              <tr><td colSpan={tableColumns?.length || 1}>Generated using FoodDo at {
                sessionStorage.getItem("date_format")
                  ?.replace(
                    "mm",
                    ("00" + ((new Date())?.getMonth() + 1)?.toString())?.slice(-2)
                  )
                  ?.replace(
                    "yy",
                    ("0000" + (new Date())?.getFullYear()?.toString())?.slice(-4)
                  )
                  ?.replace(
                    "dd",
                    ("00" + (new Date())?.getDate()?.toString())?.slice(-2)
                  )}{" "}{(new Date()).toLocaleTimeString(navigator.language, {
                    hour: '2-digit',
                    minute: '2-digit'
                  })}</td></tr>
            </tbody>
          </table>


        </div>
        {loading && (
          <div id="loadingDiv">
            <img src={spinner} alt="loading..." />
          </div>
        )}

        {pages && pages.length > 1 && <div className="pagination orders-report">
          {pages.map(p =>
            <div
              className={+currentPage === +p ? "active" : ""}
              onClick={() => pageLoad(p)}
            >
              {p}
            </div>
          )}
        </div>}

        {showChooseFileModal && <FileOutputOptions downloadHandler={downloadHandler} close={() => setShowChooseFileModal(false)} />}
      </div>
    </>
  );
}

function FilterElement({
  title,
  id,
  options,
  tableColumns,
  setTableColumns,
  isDropDownVisible,
  setIsDropDownVisible,
  filtersSelections,
  setFiltersSelections,
}) {

  function handleSelection() {
    const notAllSelected = Array.from(
      document.querySelectorAll(`[name = "${title}"]`)
    )
      .splice(1)
      .some((element) => element.checked === false);

    if (notAllSelected)
      document
        .querySelector(`[container = "${id}"]`)
        .querySelector('[id="all"]').checked = false;
    else
      document
        .querySelector(`[container = "${id}"]`)
        .querySelector('[id="all"]').checked = true;

    let selection = [];
    Array.from(document.querySelectorAll(`[name = "${title}"]`)).forEach(
      (element, i, array) => {
        element.checked &&
          element.getAttribute("label-value") !== "All" &&
          selection.push(element.getAttribute("label-value"));

        if (++i === array.length)
          setFiltersSelections({ ...filtersSelections, [title]: selection });
      }
    );
  }

  function toggleDropdown(e) {
    e.preventDefault();
    console.log('toggled dropdown');
    console.log(isDropDownVisible);
    setIsDropDownVisible(isDropDownVisible !== title ? title : null);
  }

  function autoSelectAll() {
    const notAllSelected = Array.from(
      document.querySelectorAll(`[name = "${title}"]`)
    ).some((element) => element.checked === false);

    if (notAllSelected) document.getElementById("all").checked = false;
    else document.getElementById("all").checked = true;
  }

  function selectAllHandler(e) {
    e.preventDefault();
    const checked = e.currentTarget.querySelector("input").checked;

    if (checked) {
      setFiltersSelections({ ...filtersSelections, [title]: [] });
      title === "Edit Columns" && setTableColumns(["Local Order No"]);
    } else {
      setFiltersSelections({ ...filtersSelections, [title]: options });
      title === "Edit Columns" && setTableColumns(options.slice(1));
    }
    e.currentTarget.parentNode.childNodes.forEach((i, index, array) => {

      i.querySelector("input").checked = !checked;
    });
  }

  function handleColumns(e) {
    autoSelectAll();
    let editColumns = tableColumns;
    const isChecked = e.currentTarget.checked;
    const label = e.currentTarget.getAttribute("label-value");

    editColumns = editColumns.filter((i) => i !== label);

    isChecked && editColumns.push(label);
    setTableColumns(editColumns);
  }

  useEffect(() => {

    if (!Array.isArray(tableColumns) || tableColumns.length === 0) return;
    if (title !== "Edit Columns") return;

    let DBOpenReq = window.indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    DBOpenReq.onerror = (err) => console.log(err);

    DBOpenReq.onsuccess = (ev) => {
      let db = ev.target.result;
      let store = db.transaction("user", "readwrite").objectStore("user");
      let getReq = store.get(localStorage.getItem("user_uuid"));

      getReq.onsuccess = (userRes) => {
        const user = userRes.target.result;
        user.past_order_columns = tableColumns;
        store.put(user);
      };
    };
  }, [tableColumns, title]);

  return (
    <div
      tabIndex="0"
      container={id}
      container-title={title}
      className="selection-field"
      style={{ position: "relative" }}
    >

      {title !== "Edit Columns" && <div className="field-title">{title}</div>}


      <button
        className="dropdown-trigger"
        onClick={(e) => toggleDropdown(e)}
      >
        {title === "Edit Columns" && <PencilIcon id="edit-columns-pencil" />}
        <span id="trigger-text">
          {title !== "Edit Columns" &&
            filtersSelections[title] &&
            filtersSelections[title].includes("ALL") ? (
            <span>ALL</span>
          ) : title !== "Edit Columns" &&
            filtersSelections[title] &&
            filtersSelections[title].length > 0 ? (
            filtersSelections[title].slice(0, 2).map((i) => <span>{i}</span>)
          ) : (
            title !== "Edit Columns" && <span>None</span>
          )}
          {title === "Edit Columns" && ` ${title}.${tableColumns.length} `}
        </span>
        <span className="arrow"></span>
      </button>

      {title !== "Edit Columns" &&
        filtersSelections[title] &&
        filtersSelections[title].length > 0 && (
          <div className="show-selections">
            {filtersSelections[title].map((i) => {
              return (
                <>
                  <div>{i}</div>
                </>
              );
            })}
          </div>
        )}

      <div
        className={`dropdown ${title.toLowerCase().replace(" ", "-")} ${isDropDownVisible === title ? "visible" : ""
          } `}
      >
        {options.map((opt) => (
          <div
            key={Math.random()}
            className="input-div"
            onClick={(e) => opt.toLowerCase() === "all" && selectAllHandler(e)}
            lable={opt}
          >
            <label>
              <input
                type="checkbox"
                name={title}
                id={opt.toLowerCase()}
                label-value={opt}
                onChange={(e) =>
                  title === "Edit Columns"
                    ? handleColumns(e)
                    : handleSelection()
                }

                disabled={title === "Edit Columns" && opt === "Local Order No" ? true : false}
                defaultChecked={
                  title === "Edit Columns" &&
                    ((opt.toLowerCase() === "all" &&
                      options.length === tableColumns.length + 1) ||
                      tableColumns.includes(opt))
                    ? true
                    : title !== "Edit Columns" &&
                      filtersSelections[title] &&
                      opt.toLowerCase() === "all" &&
                      options.length === filtersSelections[title].length + 1
                      ? true
                      : filtersSelections[title] &&
                        filtersSelections[title].includes(opt)
                        ? true
                        : false
                }
              />
              <div className="checkmark"></div>
              {opt}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}

function FileOutputOptions({ downloadHandler, close }) {
  const options = ["Current Page", "All Pages"];
  const [selected, setselected] = useState(options?.[0]);
  const [loading, setLoading] = useState(false);
  const cls = "fileoutput";

  return <div id={cls + "-container"}>
    <h2>Select page <Cancel onClick={close} /></h2>
    <div id={cls + "-options"}>
      {options?.map(id => <div>
        <input type="radio" id={id} name={cls} onChange={e => e.target.checked && setselected(id)} checked={selected === id} />
        <label htmlFor={id}>{id}</label>
      </div>)}
    </div>

    <button onClick={() => {
      setLoading(true);
      downloadHandler(selected, () => setLoading(false))
    }} disabled={loading}>{loading ? <img src={spinnerSVG} alt='loading...' color="white" width={'32'} height={'32'} /> : 'Submit'}</button>
  </div>
}

export default OrdersReport;